import React, { useCallback, Fragment } from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../Icon';
import { TABS_PATIENT_PORTAL } from '../../../constants';
import styles from '../index.styl';

const EmptyState = ({ activeTab, withInfo, category, formatMessage }) => {
  const { HEALTH_RECORD, MEDICATIONS } = TABS_PATIENT_PORTAL;
  const messageByType = useCallback(
    type => {
      switch (type) {
        case HEALTH_RECORD:
          return (
            <Fragment>
              <div>
                {formatMessage({
                  id: 'patient.portal.healthRecord.emptyState.nothingFound',
                })}
              </div>
              {withInfo && (
                <div>
                  {formatMessage({
                    id: 'patient.portal.healthRecord.emptyState.tryToChoose',
                  })}
                </div>
              )}
            </Fragment>
          );
        case MEDICATIONS: {
          if (withInfo) {
            return (
              <Fragment>
                <div>
                  {formatMessage({
                    id: 'patient.portal.data.noActiveMedications',
                  })}
                </div>
                <div>
                  {formatMessage({
                    id: 'patient.portal.data.noActiveMedications.tap',
                  })}
                </div>
              </Fragment>
            );
          }
          return formatMessage(
            { id: 'patient.portal.data.emptyState' },
            { type: category },
          );
        }
        default:
          return formatMessage(
            { id: 'patient.portal.data.emptyState' },
            { type: category },
          );
      }
    },
    [category],
  );
  return (
    <div className={styles.emptyStateRoot}>
      {
        <Fragment>
          <Icon size={60} name="search-list" />
          <div className={styles.noDataMessage}>{messageByType(activeTab)}</div>
        </Fragment>
      }
    </div>
  );
};

EmptyState.propTypes = {
  withInfo: PropTypes.bool,
  category: PropTypes.string,
  activeTab: PropTypes.string,
  formatMessage: PropTypes.func,
};

export default EmptyState;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/EmptyState/index.jsx